"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/layout/style/index.js
// module id = 883
// module chunks = 1